import CompanyPropertiesPanel from "@/components/CompanyPropertiesPanel/CompanyPropertiesPanel";
import HostCompanyGate from "@/components/HostCompanyGate/HostCompanyGate";
import "@/pages/MyPropertiesPage/MyPropertiesPage.scss";

function MyPropertiesPage() {
  return (
    <div className="my-properties-page">
      <HostCompanyGate>
        {(companyId) => (
          <CompanyPropertiesPanel companyId={companyId} addLinkTo="/properties/new" />
        )}
      </HostCompanyGate>
    </div>
  );
}

export default MyPropertiesPage;
